import type { CloudCostLine } from "@hasheeai/types";
export function costCell(
  lines: CloudCostLine[],
  requireBoth = false,
): { amount: number | null; partial: boolean } {
  const priced = lines.filter(
    (line) => line.amount !== null && line.currency.toUpperCase() === "USD",
  );
  const partial =
    priced.length !== lines.length ||
    lines.some((line) => line.reconciliation === "mismatch") ||
    (requireBoth && new Set(lines.map((line) => line.provider)).size < 2);
  return {
    amount: priced.length
      ? priced.reduce((sum, line) => sum + (line.amount ?? 0), 0)
      : null,
    partial: lines.length > 0 && partial,
  };
}
